import { router, useLocalSearchParams } from 'expo-router';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useEditProgram } from '@/api/hooks/programHooks';
import { Program } from '@/api/models/programModels';
import FormWrapper from '@/components/forms/FormWrapper';
import ProgramForm from '@/components/forms/ProgramForm';
import { useEndFlowModal } from '@/contexts/endFlowModalContext';
import { ProgramData } from '@/lib/validations/NpoOnboardingSchema';
import { i18n } from '@/utils/i18n';
import { safeJsonParse } from '@/utils/jsonParse';

const EditOneProgram = () => {
  const { programDataJson } = useLocalSearchParams<{
    programDataJson: string;
  }>();
  const { showSuccess } = useEndFlowModal();

  const { mutateAsync: editProgram, isPending } = useEditProgram();

  const [initialProgramData, setInitialProgramData] = useState<ProgramData | undefined>(undefined);

  const parsedProgram = safeJsonParse<Program>(programDataJson);

  useEffect(() => {
    if (programDataJson) {
      if (parsedProgram) {
        setInitialProgramData({
          title: parsedProgram.title,
          description: parsedProgram.description,
          programDate: parsedProgram.programDate,
          address: parsedProgram.address,
          name: parsedProgram.name,
          budget: parsedProgram.budget ?? 0
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programDataJson]);

  const onDone = async (data: ProgramData) => {
    try {
      if (parsedProgram && parsedProgram.id) {
        editProgram(
          {
            id: parsedProgram.id,
            name: data.name,
            title: data.title ?? data.name,
            description: data.description,
            programDate: data.programDate,
            budget: data.budget,
            address: data.address
          },
          {
            onSuccess: () => {
              showSuccess({
                title: i18n.t('end_flow.success_title'),
                message: i18n.t('profile.create_form.program_success_message')
              });
              router.back();
            },
            onError: (e) => {
              console.error(e);
            }
          }
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <SafeAreaView style={styles.container} edges={['bottom']}>
      <FormWrapper scrollEnable={false}>
        <View style={styles.content}>
          <ProgramForm initialData={initialProgramData} showDoneButton onDone={onDone} isLoading={isPending} />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },

  container: {
    flex: 1
  }
});

export default EditOneProgram;
